export default __webpack_public_path__ + "static/media/Qalqon.e3ab433b.png";